import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const LoginPage = lazy(() => import("@/pages/LoginPage").then(m => ({ default: m.LoginPage })));
const OAuthConsentPage = lazy(() => import("@/pages/OAuthConsentPage"));

export const authRoutes = (
  <>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/.lovable/oauth/consent" element={<OAuthConsentPage />} />
    {/* Legacy auth surfaces — all consolidated to /login */}
    <Route path="/auth" element={<Navigate to="/login" replace />} />
    <Route path="/forgot-password" element={<Navigate to="/login" replace />} />
    <Route path="/admin/login" element={<Navigate to="/login" replace />} />
  </>
);
